export interface IPostComment {
  ocorrenciaNo: number;
  idPost: any;
  idComentario: any;
  idPessoa: any;
  codigo: any;
  titulo: any;
  habilitado: boolean;
}
